import { Tooltip } from '@mui/material'

export default function ReportTooltip({ classes, ...props }) {
  return (
    <Tooltip
      {...props}
      classes={{
        ...classes,
        tooltip: ['ubiqua-tooltip', classes?.tooltip].filter(Boolean).join(' '),
        arrow: ['ubiqua-tooltip-arrow', classes?.arrow].filter(Boolean).join(' ')
      }}
    />
  )
}
